<template>
  <ValidationProvider :rules="rules" :vid="prefixLabel + ' ' + label" immediate v-slot="{ failed }">
    <md-field :class="{ 'md-error': failed, 'md-form-group': icon, disabled, outline, dynamic }" :md-clearable="clearable">
      <md-icon v-if="icon">{{ icon }}</md-icon>
      <label>
        {{ label }}
        <span v-if="required">&nbsp;*</span>
      </label>

      <span v-if="prefix" class="md-prefix">{{ prefix }}</span>
      <md-input
        :value="value"
        v-on:input="$emit('input', $event)"
        @keyup.enter="$emit('done', $event)"
        type="password"
        autocomplete="new-password"
        :disabled="disabled"
        :readonly="readonly"
        :required="required">
      </md-input>
      <span v-if="suffix" class="md-suffix"><small>{{ suffix }}</small></span>
      
      <slide-y-down-transition><md-icon class="error" v-show="failed">close</md-icon></slide-y-down-transition>
    </md-field>
    <span v-if="failed" class="error-msg">{{ errormsg }}</span>
  </ValidationProvider>
</template>

<script>
import { SlideYDownTransition } from "vue2-transitions";

export default {
  components: {
    SlideYDownTransition,
  },
  props: {
    required: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      default: ""
    },
    label: {
      type: String,
      default: ""
    },
    value: {
      type: String,
      default: ""
    },
    prefix: {
      type: String,
      default: ""
    },
    suffix: {
      type: String,
      default: ""
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    alpha: {
      type: Boolean,
      default: false
    },
    alphaDash: {
      type: Boolean,
      default: false
    },
    alphaNum: {
      type: Boolean,
      default: false
    },
    alphaSpaces: {
      type: Boolean,
      default: false
    },
    regex: {
      type: String,
      default: ""
    },
    errormsg: {
      type: String,
      default: "Please enter the correct information.",
    },
    names: {
      type: String,
      default: "",
    },
    outline: {
      type: Boolean,
      default: false,
    },
    dynamic: {
      type: Boolean,
      default: false,
    },
    prefixLabel: {
      type: String,
      default: "",
    },
    maxLength: {
      type: Number,
      default: 0,
    },
     minLength: {
      type: [String, Number],
      default: 2
    },
  },
  computed: {
    rules(){
      let rules = [];
      if(this.alpha) rules.push('alpha');
      if(this.alphaNum) rules.push(`alpha_num:${this.alphaNum}`);
      if(this.alphaDash) rules.push(`alpha_dash:${this.alphaDash}`);
      if(this.alphaSpaces) rules.push(`alpha_spaces:${this.alphaSpaces}`);
      if(this.required) rules.push('required');
      if(this.regex) rules.push(`regex:${this.regex}`);
      if(this.names) rules.push('names');
      if(this.maxLength) rules.push(`max:${this.maxLength}`);
      if(this.minLength) rules.push(`min:${this.minLength}`);
      return rules.join('|');
    },
  },
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
  .disabled {
    opacity: 0.7;
  }
</style>